<template>
  <div>
    <div class="header">
      <div class="row">
        <div class="small-12 columns">
          <span class="tab-message show-for-medium">Your <span v-if="showYourPartnerTab">partner's</span> investment mix <help-icon message="When making investment decisions you need to take into account how much you think you'll need for retirement. Growth assets, such as shares and property, generally offer the potential for higher returns in the long term, but with carry a higher risk of short-term volatility or negative return. Defensive assets, such as cash and fixed interest products, generally provide lower long-term returns, but can reduce the risk of a negative return in the short term. It’s important to choose the right investment mix for your needs. Please note investment returns are assumptions and are not guaranteed."></help-icon></span>

          <ul class="tabs tabs-partner" v-if="includePartner">
            <li class="tabs-title" :class="{ 'is-active': !showYourPartnerTab }">
              <a aria-selected="true" @click="actionShowYourPartnerTab({ value: false })">You</a>
            </li>
            <li class="tabs-title" :class="{ 'is-active': showYourPartnerTab }">
              <a aria-selected="true" @click="actionShowYourPartnerTab({ value: true })">Your partner</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <section>
      <p class="section-content">The way your super is invested can affect your retirement income. A medium-high risk investment mix has been used as a default. Try changing your investment mix to see the impact on your retirement income. </p>
      <div class="tabs-content">
        <div class="tabs-panel" :class="{ 'is-active': !showYourPartnerTab || !includePartner }">
          <div class="row">
            <div class="small-12 large-6 columns">
              <investment-mix :selected="inputs.InvestmentOption" @change="setInvestmentOption($event.value)">
                <h4>Before retirement <help-icon message="The expected investment return will be applied to your super balance. These returns are averages over rolling periods that incorporate expected losses."></help-icon></h4>
                <h4>Choose a mix:</h4>
                <a class="button custom-investment-mix" v-if="ui.showCustomInvestment.value" :class="{ active: inputs.InvestmentOption.value === 6}" @click="setInvestmentOption(6)">Use custom</a>
              </investment-mix>
            </div>

            <div class="small-12 large-6 columns">
              <investment-mix :selected="inputs.InvestmentOptionInRetirement" @change="setInvestmentOptionInRetirement($event.value)" :in-retirement="true">
                <h4>In retirement <help-icon message="It’s assumed that in retirement your funds will be placed in an account-based pension. Investment returns in these accounts are higher due to tax concessions, and these returns are averages over rolling periods that incorporate expected losses."></help-icon></h4>
                <h4>Choose a mix:</h4>
                <a class="button custom-investment-mix" v-if="ui.showCustomInvestment.value" :class="{ active: inputs.InvestmentOptionInRetirement.value === 6}" @click="setInvestmentOptionInRetirement(6)">Use custom</a>
              </investment-mix>
            </div>
          </div>
        </div>

        <div class="tabs-panel" :class="{ 'is-active': showYourPartnerTab }" v-if="includePartner">
          <div class="row">
            <div class="small-12 large-6 columns">
              <investment-mix :selected="inputs.InvestmentOption_2" @change="setInvestmentOption2($event.value)">
                <h4>Before retirement <help-icon message="The expected investment return will be applied to your super balance. These returns are averages over rolling periods that incorporate expected losses."></help-icon></h4>
                <h4>Choose a mix:</h4>
                <a class="button custom-investment-mix" v-if="ui.showCustomInvestment.value" :class="{ active: inputs.InvestmentOption_2.value === 6}" @click="setInvestmentOption2(6)">Use custom</a>
              </investment-mix>
            </div>

            <div class="small-12 large-6 columns">
              <investment-mix :selected="inputs.InvestmentOptionInRetirement_2" @change="setInvestmentOptionInRetirement2($event.value)" :in-retirement="true">
                <h4>In retirement <help-icon message="It’s assumed that in retirement your funds will be placed in an account-based pension. Investment returns in these accounts are higher due to tax concessions, and these returns are averages over rolling periods that incorporate expected losses."></help-icon></h4>
                <h4>Choose a mix:</h4>
                <a class="button custom-investment-mix" v-if="ui.showCustomInvestment.value" :class="{ active: inputs.InvestmentOptionInRetirement_2.value === 6}" @click="setInvestmentOptionInRetirement2(6)">Use custom</a>
              </investment-mix>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Constants } from '@/constants';

export default {
  components: {
    InvestmentMix: require('../../components/InvestmentMixControl').default,
  },
  computed: {
    ...mapState(['inputs', 'ui']),
    showYourPartnerTab() {
      return this.ui.showYourPartnerTab.value;
    },
    includePartner() {
      return this.inputs.IncludePartner.value;
    },
  },
  methods: {
    ...mapActions([
      'actionInvestmentOption',
      'actionShowYourPartnerTab',
    ]),
    setInvestmentOption(value) {
      this.actionInvestmentOption({ value, modifier: '' });
    },
    setInvestmentOptionInRetirement(value) {
      this.actionInvestmentOption({ value, modifier: 'InRetirement' });
    },
    setInvestmentOption2(value) {
      this.actionInvestmentOption({ value, modifier: Constants.PARAMETER_PARTNER_SUFFIX });
    },
    setInvestmentOptionInRetirement2(value) {
      this.actionInvestmentOption({ value, modifier: `InRetirement${Constants.PARAMETER_PARTNER_SUFFIX}` });
    },
  },
};
</script>
